<template>
    <tr :class="{ 'edit-row': isEditRequested }">
        <td>{{ supply.name }}</td>
        <td>{{ supply.unitCost }}</td>
        <td>
            <span v-if="supply.isFormulary === true">Yes</span>
            <span v-if="supply.isFormulary === false">No</span>
            <small v-if="!isSupplyFormularyBoolean">
                <i class="text-default">Not Available</i>
            </small>
        </td>
        <td>
            <div class="form-group mb-0">
                <select class="form-select" name="related-diag" v-model="supply.isRelated" v-if="isEditRequested">
                    <option :value="null">Select Relatedness</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                </select>
            </div>
            <div v-if="!isEditRequested">
                <small v-if="!isSupplyIsRelatedBoolean">
                    <i class="text-default">Not Available</i>
                </small>
                <span v-else>{{ supply.isRelated ? "Yes" : "No" }}</span>
                <span v-if="supply.isRelated === false" class="ms-1" v-tooltip="{ title: supply.notRelatedComments }">
                    <i class="fas fa-info-circle text-primary"></i>
                </span>
            </div>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="supply.startDate"> {{ formatDate(supply.startDate) }} </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        name="supplyStartDate"
                        type="text"
                        class="form-control"
                        :value="formatDateInput(supply.startDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                        :disabled="!isEditAllowed"
                        @blur="v$.supply.startDate.$touch"
                        :class="`${!v$.supply.startDate.$error ? '' : 'field-invalid'}`"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="supply.endDate"> {{ formatDate(supply.endDate) }} </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        name="supplyEndDate"
                        type="text"
                        class="form-control"
                        :value="formatDateInput(supply.endDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                        :disabled="!isEditAllowed"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <!-- ACTIONS -->
        <td class="text-end" v-if="!isEditRequested && !isDeleteRequested">
            <button type="button" class="btn table-btn btn-outline-info" @click="editSupply()">
                <i class="fas fa-edit"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                @click="requestDeleteSupply()"
                v-if="!supply.id && isEditAllowed"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <!-- EDIT -->
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEdit()">Save</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEdit()">Cancel</button>
        </td>
        <!-- DELETE -->
        <td colspan="3" v-show="isDeleteRequested">
            <TablePrompt
                :message="`Are you sure want to delete ${supply.name}?`"
                ok-text="delete"
                name="Delete"
                :ok="deleteSupply"
                :cancel="cancelDelete"
            >
            </TablePrompt>
        </td>
    </tr>
    <tr v-if="isEditRequested && supply.isRelated === false" class="row-no-hover edit-row">
        <td :colspan="columns" class="p-2 edit">
            <div class="d-flex flex-column align-items-center">
                <div class="form-group w-50">
                    <label for="not-related-reason">Reason<span class="text-danger">*</span></label>
                    <CommentInput
                        input-name="not-related-comments"
                        :result="supply.notRelatedComments"
                        placeholder="Specify rationale and pertinent medical management information."
                        max-length="2000"
                        v-on:resultUpdatedAppended="resultUpdatedAppended"
                        v-on:resultUpdated="resultUpdated"
                    >
                    </CommentInput>
                </div>
            </div>
        </td>
    </tr>
</template>

<script lang="ts" src="./SupplyTableRow.ts"></script>
